<script setup lang="ts">
import PageTitle from '@/components/PageTitle.vue';
</script>

<template>
  <page-title>Error 404</page-title>

  <div class="mt-6 mb-20 inline-block rounded-sm bg-yellow-200 p-5 text-3xl">
    <p>Page not found</p>
  </div>
</template>
